import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const EmbedIntegrationsDescription = ({ label, description, titleClassName }) => {
  const content = R.prop('content', description)
  const linkUrl = R.prop('linkUrl', description)
  const linkText = R.prop('linkText', description)

  if (description) {
    return (
      <React.Fragment>
        <Title>{label}</Title>
        <h3>Embed your survey</h3>
        {content.split('\n').map((contentLine, index) => {
          return <p key={index}>{contentLine}</p>
        })}
        <a href={linkUrl} target="_blank" rel="noopener">
          <i className="icon far fa-book" />
          {linkText}
        </a>
      </React.Fragment>
    )
  } else {
    return <Title className={titleClassName}>{label}</Title>
  }
}

EmbedIntegrationsDescription.propTypes = {
  label: PropTypes.string,
  titleClassName: PropTypes.string,
  description: PropTypes.object,
}

const Title = styled.h2`
  font-size: 1.875rem;
  margin-bottom: 0;
  margin-top: 0.5em;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedIntegrationsDescription/index.js